import React, { useCallback, useState } from 'react'
import RegisterDetails from './Register'
import { CustomTable, Loading, Popup } from 'src/components'
import { useStyles } from './styles'
import { useFilterToggler } from 'src/components/CustomTable/hooks/useFilterToggler'
import { DeathsAndDiseasesDto } from 'src/dto/deaths-and-diseases.dto'
import { useDeathsAndDiseasesTableHeader } from './hooks/useDeathsAndDiseasesTableHeader'
import { DeathsAndDiseasesHeader } from './DeathsAndDiseasesHeader'
import { useRegisterDetailsModal } from './hooks/useRegisterDetailsModal'
import { useGetDeathsAndDiseasesList } from 'src/hooks/api/deaths-and-diseases'
import { useFilteredExport } from 'src/hooks/useFilteredExport'

export const DeathsAndDiseases: React.FC = () => {
  const [deathsAndDiseasesItem, setDeathsAndDiseasesItem] = useState<DeathsAndDiseasesDto | null>(null)

  const styles = useStyles()

  const {
    data: deathsAndDiseasesDataList = [],
    isLoading,
    refetch,
    isError,
    isFetching
  } = useGetDeathsAndDiseasesList()

  const { exportData: handleExportData, handleFilteredDataChange } = useFilteredExport(deathsAndDiseasesDataList || [])

  const { filterIsActive, handleFilter } = useFilterToggler()
  const { registerDetailsModal, handleCloseModal, handleOpenModal } = useRegisterDetailsModal()

  const { tableHeader } = useDeathsAndDiseasesTableHeader({
    setDeathsAndDiseasesItem,
    handleOpenModal
  })

  const handleTableFilterChange = useCallback(
    (filteredData: { filterValue: string; filteredList: DeathsAndDiseasesDto[] }) => {
      handleFilteredDataChange(filteredData)
    },
    [handleFilteredDataChange]
  )

  const handleCreate = () => {
    setDeathsAndDiseasesItem(null)
    handleOpenModal()
  }

  const hasData = !!deathsAndDiseasesDataList?.length

  return (
    <>
      <DeathsAndDiseasesHeader
        isLoading={isLoading}
        hasData={hasData}
        onExport={handleExportData}
        onFilter={handleFilter}
        onCreate={handleCreate}
      />

      {isLoading || isFetching || isError ? (
        <Loading refetch={refetch} isError={isError} />
      ) : (
        <div className={styles.propertiesContainer}>
          <CustomTable
            filterIsActive={filterIsActive}
            header={tableHeader}
            propertiesToFilter={['ocorrencia', 'idAnimal', 'causa', 'animal', 'data']}
            body={deathsAndDiseasesDataList!}
            onFilteredDataChange={handleTableFilterChange}
          />

          {registerDetailsModal && (
            <Popup
              className={styles.usersPopup}
              title='Cadastrar Injúria'
              onClose={handleCloseModal}
              closeOnClickOutside={false}
            >
              <RegisterDetails data={deathsAndDiseasesItem} onClose={handleCloseModal} onOpen={handleCreate} />
            </Popup>
          )}
        </div>
      )}
    </>
  )
}
